/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._2X2hp0YbGa%20%5Brole%3Dtablist%5D%3Abefore%7Bdisplay%3Anone%7D%0A._0uDr6zS2te%20%5Brole%3Dtab%5D%7Boverflow-x%3Aunset%21important%7D%0A._3q9enAS2te%20%5Brole%3Dtab%5D%7Boverflow-y%3Aunset%21important%7D%0A._3ixl7MS2te%20%5Brole%3Dtab%5D%7Btext-overflow%3Aunset%21important%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2IhTon1Y8M%7Btop%3Avar(--ds-space-050%2C4px)%7D%0A._42Yu6B0Le4%7Bz-index%3A999%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._3OE6xYdnbC%7Bleft%3A0%7D%0A._38gZMsTDcB%7Bscroll-padding%3A0%2024px%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._3h2tDz3EvU%7Bscroll-behavior%3Asmooth%7D%0A._3oUqlsYbGa%7Bscrollbar-width%3Anone%7D%0A._1Oimfucjp5%3Abefore%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D%0A._1FwLP5dnbC%3Abefore%7Bmargin-top%3A0%7D%0A._0Xnm3ednbC%3Abefore%7Bmargin-right%3A0%7D%0A._2miNbsdnbC%3Abefore%7Bmargin-bottom%3A0%7D%0A._125xK8dnbC%3Abefore%7Bmargin-left%3A0%7D%0A._3Ku51Iogpp%3Abefore%7Bcontent%3A%22%22%7D%0A._31ReDydnbC%3Abefore%7Bbottom%3A0%7D%0A._3dCYwDWVPG%3Abefore%7Bposition%3Aabsolute%7D%0A._3ScelFOLYo%3Abefore%7Bwidth%3Ainherit%7D%0A._1L3m712ADO%3Abefore%7Bleft%3Avar(--ds-space-100%2C8px)%7D%0A._1D2b5M2ADO%3Abefore%7Bright%3Avar(--ds-space-100%2C8px)%7D%0A._1lBcDc4Jdh%3Abefore%7Bheight%3A2px%7D%0A._4diMdq9r67%3Abefore%7Bbackground-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._3cvhttYbGa%3A%3A-webkit-scrollbar%7Bdisplay%3Anone%7D%0A._4ApkO2dnbC%7Bright%3A0%7D");




























import React, { useCallback, useMemo, useRef, useState } from 'react';
import IconButton, { type IconButtonProps } from '@atlaskit/button/icon/button';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { calculateConditionalButtons, type ConditionalButtons, createGhost, getTabList, scrollBack, scrollForward } from './scrolling-tabs';
function isTouchDevice() {
  return 'ontouchstart' in window ||
  // eslint-disable-next-line compat/compat
  navigator.maxTouchPoints > 0;
}
type ScrollingTabListProps = {
  children: JSX.Element;
};
const initialConditionalButtonsState: ConditionalButtons = {
  back: false,
  forward: false
};
const scrollingContainerStyles = null;
const containerStyles = null;
const backButtonStyles = null;
const nextButtonStyles = null;

/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
export const ScrollingTabList = (props: ScrollingTabListProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [conditionalButtons, setConditionalButtons] = useState<ConditionalButtons>(initialConditionalButtonsState);
  const ghost = useMemo(() => createGhost(), []);
  const onTabClick = useCallback((e: Event) => {
    const target = (e.currentTarget as Element);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, []);
  React.useLayoutEffect(() => {
    const container = ref.current;
    let scrollingContainer: HTMLElement | null | undefined;
    let tabs: Element[];
    const handleConditionalButtonsChange = () => {
      const buttons = calculateConditionalButtons(scrollingContainer, isTouchDevice());
      setConditionalButtons(buttons);
    };
    const observerCallback: MutationCallback = mutationList => {
      const tablist = getTabList(ref);
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const addedNodes = (Array.from(mutation.addedNodes) as HTMLElement[]);
          const found = addedNodes.find(node => node.getAttribute('role') === 'tab');
          if (found && tablist) {
            ghost.remove();
            const tabs = Array.from(tablist.children);
            tabs.forEach(tab => {
              tab.removeEventListener('click', onTabClick);
              tab.addEventListener('click', onTabClick);
            });
            tablist.appendChild(ghost);
            handleConditionalButtonsChange();
          }
        }
      }
    };
    const observer = new MutationObserver(observerCallback);
    if (container) {
      const tablist = getTabList(ref);
      scrollingContainer = tablist?.parentElement;
      observer.observe(container, {
        attributes: false,
        childList: true,
        subtree: true
      });
      if (scrollingContainer instanceof HTMLElement && tablist) {
        tablist.appendChild(ghost);
        tabs = Array.from(tablist.children);
        tabs.forEach(tab => tab.addEventListener('click', onTabClick));
        handleConditionalButtonsChange();
        scrollingContainer.addEventListener('scroll', handleConditionalButtonsChange);
      }
      return () => {
        if (scrollingContainer) {
          // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
          scrollingContainer.removeEventListener('scroll', handleConditionalButtonsChange);
        }
        if (tabs.length) {
          tabs.forEach(tab => tab.removeEventListener('click', onTabClick));
        }
      };
    }
  }, [onTabClick, ghost, ref]);
  const buttonProps: Partial<IconButtonProps> = {
    appearance: 'subtle',
    spacing: 'compact'
  };
  return <div ref={ref} data-testid="scrolling-tabs" className={ax(["_1mT5xdRAKS _2X2hp0YbGa _0uDr6zS2te _3q9enAS2te _3ixl7MS2te"])}>
			{conditionalButtons.back && <div className={ax(["_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _3OE6xYdnbC", "back"])}>
					<IconButton data-test-id="back" onClick={() => scrollBack(ref)} label="back" icon={iconProps => <ChevronLeftIcon {...iconProps} size="small" />} {...buttonProps} />
				</div>}
			<div className={ax(["_38gZMsTDcB _4bt5LAIZbP _3h2tDz3EvU _3oUqlsYbGa _1Oimfucjp5 _1FwLP5dnbC _0Xnm3ednbC _2miNbsdnbC _125xK8dnbC _3Ku51Iogpp _31ReDydnbC _3dCYwDWVPG _3ScelFOLYo _1L3m712ADO _1D2b5M2ADO _1lBcDc4Jdh _4diMdq9r67 _3cvhttYbGa"])}>{props.children}</div>
			{conditionalButtons.forward && <div className={ax(["_1mT5xdWVPG _2IhTon1Y8M _42Yu6B0Le4 _0KLXrulfZc _4ApkO2dnbC"])}>
					<IconButton data-test-id="forward" onClick={() => scrollForward(ref)} {...buttonProps} label="forward" icon={iconProps => <ChevronRightIcon {...iconProps} size="small" />} />
				</div>}
		</div>;
};